import { IChatSession } from 'src/@types/chat';
import { create } from 'zustand';

interface GatheringChatState {
  sessionId: string | null;
  setSessionId: (sessionId: string) => void;
  chatSessionsList: Record<string, IChatSession>;
  addChatSessionToList: (chat: IChatSession) => void;
  closeChatSession: (chatId: string) => void;
}

export const useGatheringChatState = create<GatheringChatState>((set, get) => ({
  sessionId: null,
  setSessionId: (sessionId) => set({ sessionId }),
  chatSessionsList: {},
  addChatSessionToList: (session) => {
    const { chatSessionsList } = get();
    set({
      chatSessionsList: {
        ...chatSessionsList,
        [session._id]: session,
      },
    });
  },
  closeChatSession: (sessionId) => {
    const { chatSessionsList } = get();
    delete chatSessionsList[sessionId];
    set({ chatSessionsList });
  },
}));
